import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleSelect = (url: string) => {
    setOpen(false);
    window.open(url, '_blank', 'noopener,nofollow');
  };

  return (
    <section className="w-full bg-background-50 py-8 md:py-12">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Browse Basetao Spreadsheet Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Select a category below to explore curated product spreadsheets on our main website
          </p>
        </div>

        <div className="max-w-md mx-auto" ref={ref}>
          <div className="relative">
            <button
              onClick={() => setOpen(!open)}
              className="w-full flex items-center justify-between px-5 py-3.5 rounded-lg bg-background-100 border border-background-300/60 text-foreground-800 text-sm font-medium hover:border-primary-400 transition-colors cursor-pointer"
            >
              <span>Select a Category</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`text-lg transition-transform duration-200 ${open ? 'ri-arrow-down-s-line rotate-180' : 'ri-arrow-down-s-line'}`}></i>
              </div>
            </button>

            {open && (
              <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200/70 rounded-lg overflow-hidden z-40 max-h-72 overflow-y-auto">
                {categories.map((cat) => (
                  <button
                    key={cat.name}
                    onClick={() => handleSelect(cat.url)}
                    className="w-full flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 transition-colors text-left cursor-pointer whitespace-nowrap"
                  >
                    <div className="w-5 h-5 flex items-center justify-center text-primary-500">
                      <i className={`${cat.icon} text-base`}></i>
                    </div>
                    {cat.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}